import React from "react";
import { Section, Eyebrow, Reveal, KW } from "./shared";
import { ROADMAP } from "../../lib/site";

const flow = ["Research", "Create", "Discover", "Trust", "Capture", "Convert"];
const colors = ["#0B31EB", "#E90019", "#4CAF48", "#FFCB52", "#0B31EB", "#E90019", "#4CAF48"];

export default function Roadmap() {
  return (
    <Section id="roadmap" bg="bg-brand-cream">
      <Reveal className="max-w-3xl">
        <Eyebrow color="#4CAF48">The Complete System</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98] mt-5">
          From <KW c="#4CAF48">Expertise</KW> to Customer
        </h2>
        <p className="text-base sm:text-lg text-brand-ink/75 mt-5">
          You are not joining to learn isolated YouTube tricks. You are learning how the complete system works together.
        </p>
      </Reveal>

      {/* Snake / zigzag timeline */}
      <div className="relative mt-14">
        <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-1 bg-brand-black/10 md:-translate-x-1/2 rounded-full" aria-hidden />
        <div className="space-y-6 md:space-y-0">
          {ROADMAP.map((r, i) => (
            <Reveal key={r.n} delay={(i % 2) * 0.05}>
              <div className={`relative md:grid md:grid-cols-2 md:gap-12 ${i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""}`}>
                <div className={`pl-16 md:pl-0 ${i % 2 === 0 ? "md:pr-12 md:text-right" : "md:pl-12"} md:py-6`}>
                  <div className="rounded-[24px] border-2 border-brand-black bg-white p-6 inline-block w-full"
                    style={{ boxShadow: `8px 10px 0 ${colors[i]}` }}>
                    <span className="font-display text-xl" style={{ color: colors[i] }}>Stage {r.n}</span>
                    <h3 className="font-display text-2xl sm:text-3xl mt-1">{r.t}</h3>
                    <p className="text-sm text-brand-ink/75 mt-2 leading-relaxed">{r.d}</p>
                  </div>
                </div>
                {/* node */}
                <span className="absolute left-6 md:left-1/2 top-8 md:top-1/2 -translate-x-1/2 md:-translate-y-1/2 h-11 w-11 rounded-full border-2 border-brand-black flex items-center justify-center font-display text-white z-10"
                  style={{ background: colors[i] }}>{r.n}</span>
                <div className="hidden md:block" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Final flow */}
      <Reveal delay={0.1}>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-2 sm:gap-3">
          {flow.map((f, i) => (
            <React.Fragment key={f}>
              <span className="rounded-full border-2 border-brand-black bg-white px-4 py-2 font-bold text-xs sm:text-sm">{f}</span>
              {i < flow.length - 1 && <span className="font-display text-brand-red">→</span>}
            </React.Fragment>
          ))}
        </div>
      </Reveal>
    </Section>
  );
}
